import { render, staticRenderFns } from "./WritTemplate.vue?vue&type=template&id=a371c636&scoped=true"
import script from "./WritTemplate.vue?vue&type=script&lang=js"
export * from "./WritTemplate.vue?vue&type=script&lang=js"
import style0 from "./WritTemplate.vue?vue&type=style&index=0&id=a371c636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a371c636",
  null
  
)

export default component.exports